define(function (require) {
    var logger = require('system.logger').get('system.helper.Event');
    
    var Event = function () {
        this._events = {};

        this._bindingObj = {};
    };

    Event.prototype = {
        /**
         *  Call before emit. Emit will refers to defined object
         * 
         * @param {object} Object which will be binded to emit
         * @returns {object} this
         */
        bindTo: function (obj) {
            this._bindingObj = obj;

            return this;
        },
        emit: function (event) {
            var self = this,
                    args = Array.prototype.slice.call(arguments),
                    callbackCount = 0,
                    resolvedCallbackCount = 0,
                    callbackResponseList = [];

            args.shift(); // remove event name from arguments
            
            return new Promise(function (resolve, reject) {
                if (typeof self._events[event] !== 'undefined' && self._events[event] instanceof Array) {
                    for (var i in self._events[event]) {
                        if (typeof self._events[event][i].listener === 'function') {
                            var funcArgs = args.slice(0); // copy array without reference

                            // resolve method with passing a callback also
                            if (self._events[event][i].withCallback) {

                                ++callbackCount;

                                funcArgs.push(function (err, response) {
                                    if (err) {
                                        reject(err);
                                        return;
                                    }

                                    callbackResponseList.push(response);
                                    ++resolvedCallbackCount;

                                    // all callback are completed
                                    if (resolvedCallbackCount === callbackCount) {
                                        resolve(callbackResponseList);
                                    }
                                });
                            }

                            self._events[event][i].listener.apply(self._bindingObj, funcArgs);
                        } else {
                            logger.debug('Event %s is not callable', event);
                        }
                    }

                    // if no listeners with callback
                    if (callbackCount === 0) {
                        resolve(callbackResponseList);
                    }
                } else {
                    logger.debug('Event %s not defined.', event);
                    resolve(callbackResponseList);
                }

                self._bindingObj = {};
            });
        },
        on: function (event, listener, withCallback) {
            withCallback = withCallback || false;

            if (typeof this._events[event] === 'undefined') {
                this._events[event] = [];
            }
            this._events[event].unshift({listener: listener, withCallback: withCallback});

            logger.info('Attaching event %s with callback ', event, withCallback);

            return this;
        },
        removeListener: function (event, listener) {
            if (typeof this._events[event] === 'undefined') {
                return;
            }

            for (var i in this._events[event]) {
                if (this._events[event][i].listener === listener) {
                    this._events[event].splice(i, 1);
                }
            }
        },
        off: function (event) {
            this._events[event] = null;

            delete this._events[event];
        },
        removeAllEvents: function () {
            for (var event in this._events) {
                this._events[event].length = 0;
            }
        }
    };

    return Event;
});